/**
 * sandbox.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { animate, Component, OnInit, state, style, transition, trigger }
  from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";

import { jsonify } from "../support/utilities/functions";
import { SearchService } from "app/search/search.service";
import { MessagingService } from "app/server/messaging.service";
import { PingRequest, ReplyMessage, Message, AcknowledgmentResponse } from "app/server/messages/general";
import { SubjectService } from "app/subjects/subject.service";
import { SoundsService } from "app/support/APIs/sounds.service";
import { ExtensionSignalRequest, ExtensionPayload } from "app/server/messages/collaboration/extension-signal-request";
import { AuthService } from "app/auth/auth.service";
import { interpolateString } from "app/server/validation/interpolation";
import { Variable } from "app/aggregation/typed-parameter";

/**
 * {@link SandboxComponent} is a special page only accessible in debug-mode
 * designed as a safe place to test.
 */
@Component({
  template: `
  <div class="container" style="border: 2px yellow solid;">
  <iframe src="http://localhost:4200/" style="border: 2px green solid;" width="1400" height="700"></iframe>
  </div>

  <div class="container">
    <div class="well">
      List: {{control.value | json}}
    </div>
    <ul>
      <li>
        <button class="btn btn-default">Default</button>
      </li>
      <li>
        <button class="btn btn-primary">Standard / navigational action </button>
      </li>
      <li>
        <button class="btn btn-success">Save / confirmation action</button>
      </li>
      <li>
        <button class="btn btn-warning">Ignore / caution action</button>
      </li>
      <li>
        <button class="btn btn-danger">Destructive / dangerous action</button>
      </li>
      <li>
        <button class="btn btn-info">Special / informative action</button>
      </li>
    </ul>
  </div>

  <div class="container">
    <h3>
      Messaging Tests
      <!-- <button class="btn btn-sm btn-warning" (click)="send()" [disabled]="subjects.subjects.length == 0">
        Send Remove for s0 (
          {{subjects.subjects[0]?.readableTitle}}
          <em *ngIf="subjects.subjects.length == 0">none</em>
        )
      </button> -->
      <button class="btn btn-sm btn-warning" (click)="send()">Guestify</button>
      <input type="text" class="form-control" [value]="pingResult">
    </h3>
    <h3>
      repeatTo test
      <button class="btn btn-sm btn-info" (click)="rando()">Randomize</button>
      </h3>
    <ol>
      <li *repeatTo="x; let i = index">
        i = {{i}}
      </li>
    </ol>
  </div>

  <div class="container">
    <h3>Synth Tests</h3>
    <p>
          <button class="btn btn-success" (click)="boop()">Play!</button>
    </p>
  </div>

  <div class="container">
          <h3>Interp Test</h3>
          <code>{{genericDisplay}}</code>
  </div>
  `,
  styles: [`li {margin-top: 10px;} .btn {width: 240px;}`],
  animations: []
  //  [
	// 	trigger("count", [
  //       state("*", style({backgroundColor: "lightgray"})),
  //       transition("* => *", [
  //         style({backgroundColor: "yellow"}),
  //         animate(1000)
  //       ])
  //     ])
  // ]
})
export class SandboxComponent implements OnInit
{
  public control : FormControl;

  public x : number = 7;
  public rando () : void
  {
    let r : number = Math.floor(Math.random() * 10) + 5;
    if (r === this.x)
    {
      r--;
    }
    this.x = r;
  }

  public genericDisplay : string = "";

  public pingResult : string = "";
  public send () : void
  {
    this.auth.guestLogin().subscribe((_ : boolean) => {
      this.pingResult = `${_}`;
      this.auth.redirect();
    });
  }

  public boop () : void
  {
    // this.sounds.debugTest();
    this.sounds.playSound("chat");
  }

  public constructor (
    router : Router,
    search : SearchService,
    public messaging : MessagingService,
    public subjects : SubjectService,
    public sounds : SoundsService,
    public auth : AuthService
    ) {
    /* DI-only */
  }

  private terpVars : Array<Variable<any>> = [
    {
      name : "dogNames",
      type : "string",
      cardinality : 0,
      collectionType : "list",
      value : ["Fido", "Rufus", "Poncho"]
    },
    {
      name : "dogBreeds",
      type : "string",
      cardinality : 0,
      collectionType : "list",
      value : ["Pekingese", "Golden", "Pitoodle"]
    },
    {
      name : "dogCounts",
      type : "whole number",
      cardinality : 0,
      collectionType : "list",
      value : [0, 2, 5]
    }
  ];

  public ngOnInit () : void
  {
    this.control = new FormControl([]);
    // setInterval(() => this.variable.value = Math.random() * 100, 1000);

    this.genericDisplay = interpolateString(
      "${dogNames|zip,${dogBreeds}} | ${dogCounts}",
      this.terpVars.slice(0)
    );

  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/debug/sandbox.component.ts